import type { JSX } from 'react';
import Box from 'carbon-react/esm/components/box';
import Button from 'carbon-react/esm/components/button/__next__';
import Typography from 'carbon-react/esm/components/typography';
import { blurOnClick } from '../../../../utils/blurOnClick';
import { CollaboratorsViewProps } from './CollaboratorsList';

const CollaboratorsCards = ({
  collaborators,
  getProfileLabel,
  setSelectedCollaborator,
  setEditDialogId,
  setDeleteDialogId,
}: CollaboratorsViewProps): JSX.Element => {
  const mobileCollaboratorView = (
    <Box display="flex" flexDirection="column" gap={0}>
      {collaborators.map(collab => (
        <Box key={collab.instanceId} p={2} bg="white">
          <Typography variant="h4" mb={1}>
            {collab.firstName} {collab.lastName}
          </Typography>
          <Typography
            variant="segment-subheader-alt"
            mb={1}
            // fontStyle={!collab.isActive ? 'italic' : 'normal'}
            weight={!collab.isActive ? 'regular' : undefined}
          >
            {collab.email}
          </Typography>
          <Typography
            variant="segment-subheader"
            mb={2}
            // fontStyle={!collab.isActive ? 'italic' : 'normal'}
            weight={!collab.isActive ? 'regular' : undefined}
          >
            Profil: {getProfileLabel(collab)}
          </Typography>
          <Box display="flex" gap={1} justifyContent="flex-end">
            <Button
              onClick={e => {
                blurOnClick(e);
                setEditDialogId(collab.instanceId);
                setSelectedCollaborator(collab);
              }}
              variantType="subtle"
              size="small"
              iconType="edit"
              aria-label="Modifier"
            />
            <Button
              onClick={e => {
                blurOnClick(e);
                setDeleteDialogId(collab.instanceId);
                setSelectedCollaborator(collab);
              }}
              variantType="subtle"
              size="small"
              iconType="delete"
              aria-label="Supprimer"
            />
          </Box>
        </Box>
      ))}
    </Box>
  );

  return mobileCollaboratorView;
};

export default CollaboratorsCards;
